import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cx-spinner" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["r", "cx", "cy", "stroke-width"]
const _hoisted_4 = {
  key: 0,
  class: "cx-spinner__text"
}

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CxSpinner',
  props: {
  size: {
    type: Number,
    default: 50
  },
  width: {
    type: Number,
    default: 3
  },
  loadingText: String
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: __props.size,
      height: __props.size
    }, [
      _createElementVNode("circle", {
        class: "cx-spinner__loader",
        r: __props.size / 2 - __props.width,
        cx: __props.size / 2,
        cy: __props.size / 2,
        stroke: "black",
        fill: "none",
        "stroke-width": __props.width,
        "stroke-dasharray": "25, 200",
        "stroke-dashoffset": "0",
        "stroke-linecap": "round"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2)),
    (__props.loadingText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.loadingText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})